<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- 专注模式开关 -->
        <el-switch
          class="right-menu-item"
          :value="concentrateMode"
          @change="changeMode"
        />

        <div class="modeText right-menu-item">
          {{ concentrateMode ? '专注编辑' : '传统编辑' }}
        </div>

        <search id="header-search" class="right-menu-item" />

        <error-log
          class="errLog-container right-menu-item hover-effect"
        />

        <screenfull
          id="screenfull"
          class="right-menu-item hover-effect"
        />
      </template>

      <el-dropdown
        v-if="sysRole.length"
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <svg-icon icon-class="setting" class="logout-icon" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link
            v-for="(item, index) in sysRole"
            :key="index"
            :to="item.path"
          >
            <el-dropdown-item>{{ item.name }}</el-dropdown-item>
          </router-link>
          <!-- <router-link to="/user/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <router-link to="/usermanage/index">
            <el-dropdown-item>用户管理</el-dropdown-item>
          </router-link>
          <router-link to="/permission/index">
            <el-dropdown-item>权限管理</el-dropdown-item>
          </router-link>
          <router-link to="/section/index">
            <el-dropdown-item>项目管理</el-dropdown-item>
          </router-link>-->
        </el-dropdown-menu>
      </el-dropdown>

      <div class="right-menu-item">{{ name }}</div>
      <div class="right-menu-item" style="margin-right:30px;">
        <svg-icon
          icon-class="tuichu"
          class="logout-icon"
          @click="logout"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import Search from '@/components/HeaderSearch'
import Cookies from 'js-cookie'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    Search
  },
  data() {
    return {
      isSetMode: undefined
    }
  },
  computed: {
    ...mapState({
      concentrateMode: state => state.editMode.concentrateMode
    }),
    ...mapGetters(['sidebar', 'avatar', 'device', 'name']),
    sysRole() {
      const arr = [{ name: '账号管理', path: '/account/index' }]
      return arr
      // const roles = this.$store.getters.roles;
      // let bool;
      // if (roles.length) {
      //   bool = roles.find(item => item.code === "sys_setting");
      // } else {
      //   bool = false;
      // }

      // if (roles.length && bool) {
      //   const arr = [];
      //   bool.children.forEach(item => {
      //     if (item.name === "个人中心") {
      //       arr.push({ name: item.name, path: "/user/index" });
      //     }
      //     if (item.name === "用户管理") {
      //       arr.push({ name: item.name, path: "/usermanage/index" });
      //     }
      //     if (item.name === "权限管理") {
      //       arr.push({ name: item.name, path: "/permission/index" });
      //     }
      //     if (item.name === "项目管理") {
      //       arr.push({ name: item.name, path: "/section/index" });
      //     }
      //   });
      //   return arr;
      // } else {
      //   return [];
      // }
    }
  },
  created() {},
  mounted() {
    this.isSetMode = Cookies.get('concentrateMode')
    if (this.isSetMode) {
      this.changeMode()
    } else {
      if (
        this.concentrateMode &&
				(this.$route.name == 'concentrateMaterial' ||
					this.$route.name == 'concentrateLogistics')
      ) {
        // 当前是专注编辑，转为传统编辑
        // 进入带当前参数的传统模式
        this.$router.push({
          name:
						this.$route.name == 'concentrateMaterial'
						  ? 'materialedit'
						  : 'logisticsedit',
          params: currentParams
        })
      }
    }
  },
  methods: {
    changeMode() {
      // 记录当前页面参数
      var currentParams = this.$route.params
      // 删除当前页面
      var currentRoute = this.$route
      this.$store.dispatch('editMode/triggerMode') // 切换顶部栏模式按钮状态
      if (
        this.concentrateMode &&
				(this.$route.name == 'materialedit' ||
					this.$route.name == 'logisticsedit')
      ) {
        this.$store.dispatch('tagsView/delVisitedView', currentRoute) // 删除当前路由
        // 当前是传统编辑，转成专注编辑
        // 进入带当前参数的专注模式
        this.$router.push({
          name:
						this.$route.name == 'materialedit'
						  ? 'concentrateMaterial'
						  : 'concentrateLogistics',
          params: currentParams
        })
      }
      if (
        !this.concentrateMode &&
				(this.$route.name == 'concentrateMaterial' ||
					this.$route.name == 'concentrateLogistics')
      ) {
        this.$store.dispatch('tagsView/delVisitedView', currentRoute) // 删除当前路由
        // 当前是专注编辑，转为传统编辑
        // 进入带当前参数的传统模式
        this.$router.push({
          name:
						this.$route.name == 'concentrateMaterial'
						  ? 'materialedit'
						  : 'logisticsedit',
          params: currentParams
        })
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$confirm('退出后将返回登录页', '是否退出当前系统', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('user/logout').then(res => {
            this.$store
              .dispatch('tagsView/delAllViews')
              .then(res => {
                this.$message({
                  message: '退出成功',
                  type: 'success'
                })
                this.$router.push(`/login`)
              })
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
	height: 50px;
	overflow: hidden;
	position: relative;
	background: #fff;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

	.hamburger-container {
		line-height: 46px;
		height: 100%;
		float: left;
		cursor: pointer;
		transition: background 0.3s;
		-webkit-tap-highlight-color: transparent;

		&:hover {
			background: rgba(0, 0, 0, 0.025);
		}
	}

	.breadcrumb-container {
		float: left;
	}

	.errLog-container {
		display: inline-block;
		vertical-align: top;
	}

	.right-menu {
		float: right;
		height: 100%;
		line-height: 50px;

		&:focus {
			outline: none;
		}

		.el-switch {
			line-height: unset !important;
		}

		.right-menu-item {
			display: inline-block;
			padding: 0 8px;
			height: 100%;
			font-size: 14px;
			color: #5a5e66;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background 0.3s;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}
			}
		}

		.avatar-container {
			.avatar-wrapper {
				position: relative;
			}
		}
	}
	.logout-icon {
		font-size: 26px;
		margin-top: 12px;
	}
}
</style>
